module.exports = __webpack_public_path__ + "static/media/activity-bg-2.c29579f7.svg";